var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitoringHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 8V9.88872C4.94349 10.2953 4.75845 10.6753 4.45402 10.946C4.14958 11.2166 3.75047 11.3559 3.34375 11.3333H0.90625",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.90625 10.1146V12.1458",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14904 6.82356L1.08571 4.93095C0.981639 4.90306 0.892907 4.83497 0.839035 4.74166C0.785162 4.64835 0.770564 4.53747 0.79845 4.43339L1.32418 2.47136C1.49149 1.84692 1.90002 1.31452 2.45987 0.991291C3.01973 0.668059 3.68505 0.580467 4.30949 0.747784L12.9425 3.06098C13.1506 3.11675 13.3281 3.25293 13.4358 3.43954C13.5436 3.62616 13.5728 3.84794 13.517 4.05608L13.3382 4.72318C13.2976 4.87503 13.2137 5.01183 13.0969 5.11698C12.98 5.22213 12.8351 5.29112 12.6798 5.31559L9.24915 5.85715L9.14415 6.24904C9.08838 6.45718 8.9522 6.63465 8.76558 6.74239C8.57897 6.85014 8.35719 6.87933 8.14904 6.82356Z",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4449 5.51067L10.6856 8.34437C10.6298 8.55252 10.4937 8.72998 10.3071 8.83773C10.1204 8.94547 9.89866 8.97467 9.69051 8.9189L2.62718 7.02628C2.21089 6.91474 1.85596 6.64239 1.64047 6.26915C1.42498 5.89592 1.36659 5.45236 1.47813 5.03607",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.781 6.80295L12.3604 8.37258",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringHeartIcon);
export default __webpack_public_path__ + "static/media/monitoringHeartIcon.d5aa66de08d4ecabb303f9a5c0a199a5.svg";
export { ForwardRef as ReactComponent };